import httpClient from "../httpClient";
import { API_USER_CREATE } from "../config";

const createUser = {
  create: (data) => httpClient.post(API_USER_CREATE, data),
};

export default createUser;
